var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcListDetail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-list-detail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.314,
    height: 21.275,
    viewBox: "0 0 24.314 21.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "list-alt-regular",
    d: "M22.035,32H2.279A2.279,2.279,0,0,0,0,34.279V51a2.279,2.279,0,0,0,2.279,2.279H22.035A2.279,2.279,0,0,0,24.314,51V34.279A2.279,2.279,0,0,0,22.035,32ZM21.75,51H2.564a.285.285,0,0,1-.285-.285V34.564a.285.285,0,0,1,.285-.285H21.75a.285.285,0,0,1,.285.285V50.711A.285.285,0,0,1,21.75,51Zm-1.995-4.369v1.14a.57.57,0,0,1-.57.57h-9.5a.57.57,0,0,1-.57-.57v-1.14a.57.57,0,0,1,.57-.57h9.5A.57.57,0,0,1,19.755,46.627Zm0-4.559v1.14a.57.57,0,0,1-.57.57h-9.5a.57.57,0,0,1-.57-.57v-1.14a.57.57,0,0,1,.57-.57h9.5A.57.57,0,0,1,19.755,42.068Zm0-4.559v1.14a.57.57,0,0,1-.57.57h-9.5a.57.57,0,0,1-.57-.57v-1.14a.57.57,0,0,1,.57-.57h9.5A.57.57,0,0,1,19.755,37.509Zm-11.967.57a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,7.788,38.079Zm0,4.559a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,7.788,42.638Zm0,4.559a1.71,1.71,0,1,1-1.71-1.71A1.71,1.71,0,0,1,7.788,47.2Z",
    transform: "translate(0 -32)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListDetail);
export default __webpack_public_path__ + "static/media/ic-list-detail.4db8bc6c50e014d6742ef6d5b445d0f6.svg";
export { ForwardRef as ReactComponent };